import { render, staticRenderFns } from "./MetaObjectSelector.vue?vue&type=template&id=116335a8&scoped=true&"
import script from "./MetaObjectSelector.vue?vue&type=script&lang=js&"
export * from "./MetaObjectSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116335a8",
  null
  
)

export default component.exports